import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import {BookService} from "../book/book.service";

export const bookResolver: ResolveFn<any> = (route) => {
  const bookService = inject(BookService);
  const id = route.paramMap.get('id')!;
  return bookService.get(id);
};
